import { validatePresenceOf, formatLegalActDate } from '@/shared/utils';

export const validate = act => {
  return validatePresenceOf(act, ['date', 'office']);
};

export const buildContent = act => {
  var line = `Suivant acte en date du ${formatLegalActDate(act.date)} dressé par ${act.office}.`;
  return [line];
};